<template>
  <div id="role-form">
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: Form Layout -->
        <div class="intro-y box p-5">

          <div class="mt-3">
            <label for="password" class="form-label"><span class="text-danger">*</span> 現時密碼</label>
            <input v-model="form.password" id="password" type="password" class="form-control w-full" placeholder="請輸入現時密碼">
            <div v-if="'password' in errors" class="text-danger mt-2" v-html="errors.password"></div>
          </div>

          <div class="mt-3">
            <label for="newPassword" class="form-label"><span class="text-danger">*</span> 新密碼</label>
            <input v-model="form.newPassword" id="newPassword" type="password" class="form-control w-full" placeholder="請輸入新密碼">
            <div v-if="'newPassword' in errors" class="text-danger mt-2" v-html="errors.newPassword"></div>
          </div>

          <div class="mt-3">
            <strong>密碼必須包含:</strong>
            <ul>
              <li>最少8個字符</li>
              <li>最少一個大寫字母</li>
              <li>最少一個小寫字母</li>
              <li>最少一個數字</li>
              <li>無空格</li>
            </ul>
          </div>

          <div class="flex justify-end align-items-center mt-5">
            <router-link v-if="!loading && !finish" to="/profile" type="button" class="btn btn-outline-secondary w-24 mr-1">取消</router-link>
            <button v-if="!loading && !finish" type="button" class="btn btn-primary w-24" @click="onSave">儲存</button>
            <span v-show="loading && !finish"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
        </div>
        <!-- END: Form Layout -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      form: {
        password: null,
        newPassword: null
      },
      errors: {},
      loading: false,
      finish: false
    }
  },
  watch: {
  },
  mounted() {
    window.tailwind.svgLoader()
  },
  methods: {
    onSave: async function() {
      this.loading = true
      this.errors = {}

      const response = await this.updatePassword(this.form)

      if ('errors' in response.data) {
        this.errors = response.data.errors
        this.loading = false
      } else {
        let option = {
          title: '已成功更改密碼',
          message: '請稍後，將會轉至個人檔案頁面',
          type: 'success'
        }

        if (response.code === 0) {
          this.finish = true

          setTimeout(() => {
            this.$router.push('/profile')
          }, 1000)
        } else {
          this.loading = false
          option = {
            title: '未能更改密碼',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
